import { EmptyList as OrdersList } from './List';

export default OrdersList;
